export var AssetPropertiesOwnership;
(function (AssetPropertiesOwnership) {
    AssetPropertiesOwnership["Override"] = "override";
    AssetPropertiesOwnership["Inherit"] = "inherit";
})(AssetPropertiesOwnership || (AssetPropertiesOwnership = {}));
export var AppMode;
(function (AppMode) {
    AppMode["Off"] = "off";
    AppMode["On"] = "on";
    AppMode["Risk"] = "risk";
})(AppMode || (AppMode = {}));
